import React, { useState } from 'react';
import SendMessage from './modal/send_message-test.modal';
import EmailPreviewModal from './modal/email-preview.modal';
import Icon from '../forms/icon.component';
import { useLocation } from 'react-router-dom';
import { AlertService } from '../../services/alert.service';

interface Props {
  payload?: any;
  varsEmail?: any;
  examplesCampaigns?: any;
  subject?: string;
}

const MockupEmail = React.forwardRef<HTMLDivElement, Props>(
  ({ payload, varsEmail, examplesCampaigns, subject }, ref) => {
    const validPaths = [
      '/sendCampaigns/flows-campaigns',
      '/sendCampaigns/fallback-campaigns',
      '/sendCampaigns/standard-campaigns'
    ];
    const location = useLocation();
    const isValidRoute = validPaths.includes(location.pathname);

    const [showModal, setShowModal] = useState({
      show: false,
      data: { typeModal: 'email' }
    });
    const [showPreviewModal, setShowPreviewModal] = useState({
      show: false,
      data: { typeModal: 'email' }
    });

    const handleShowModal = async () => {
      setShowModal({ show: false, data: { typeModal: 'email' } });
    };

    const handleShowPreviewModal = () => {
      setShowPreviewModal({ show: false, data: { typeModal: 'email' } });
    };

    const handleOpenPreview = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setShowPreviewModal({ show: true, data: { typeModal: 'email' } });
    };

    if (!payload) {
      return (
        <div ref={ref} className="email-mockup-empty bg-body">
          <div className="empty-state">
            <Icon icon="ki-sms" size="fs-3x" type="muted" />
            <p className="mt-3 text-muted">
              Selecciona una plantilla de email para ver la vista previa
            </p>
          </div>
        </div>
      );
    }

    return (
      <>
        <div ref={ref} className="card bg-body">
          <div className="card-body">
            <div className="d-flex flex-column justify-content-between">
              <div className="mb-0">
                <div className="text-center text-dark fs-5 fw-bolder pt-4 pb-1 mb-10">
                  Mira cómo luce tu plantilla seleccionada o envía un mensaje de prueba.
                </div>
              </div>
              <div className="flex-grow-1 bgi-no-repeat bgi-size-contain bgi-position-x-center bgi-position-y-bottom card-rounded-bottom max-h-175px min-h-175px preview-image-email mb-15"></div>
              <div className="row">
                <div className="col-12 col-md-6 text-start mb-3 mb-md-0">
                  <button
                    className="btn btn-light-primary fw-bolder fs-6 px-6"
                    type="button"
                    onClick={(e: any) => {
                      if (payload.html) handleOpenPreview(e);
                      else
                        AlertService.toastWarning(
                          '¡ Atención ! Selecciona una plantilla de email para ver la vista previa'
                        );
                    }}
                  >
                    Vista previa
                  </button>
                </div>

                <div className="col-12 col-md-6">
                  {/* {isValidRoute && (
                    <>
                      <button
                        className="btn btn-light-info fw-bolder fs-6 px-6"
                        type="button"
                        onClick={() => setShowModal({ show: true, data: { typeModal: 'email' } })}
                      >
                        Envío prueba
                      </button>
                      <SendMessage
                        show={showModal.show}
                        onRequestClose={handleShowModal}
                        typeMockup={'email'}
                      />
                    </>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <EmailPreviewModal
          show={showPreviewModal.show}
          onRequestClose={() => handleShowPreviewModal()}
          payload={payload}
          varsEmail={varsEmail}
          examplesCampaigns={examplesCampaigns}
          subject={subject as string}
        />
      </>
    );
  }
);

export default MockupEmail;
